import styled from 'styled-components';
import { Container } from '@mindly/ui-components';

export const PaymentPageContainer = styled(Container)`
  margin-top: 20px;

  padding: 0 0 50px 0;
`;

type PaymentPageRowProps = {
  border?: boolean;
  withContainer?: boolean;
  spaceBetween?: boolean;
};
export const PaymentPageRow = styled.div<PaymentPageRowProps>`
  ${({ spaceBetween }) => spaceBetween && 'display: flex; justify-content: space-between;'}
  border-bottom: ${(props) => (props.border ? '1px solid #eeeeee' : 'none')};
  padding-left: ${(props) => (props.withContainer ? '16px' : '0')};
  padding-right: ${(props) => (props.withContainer ? '16px' : '0')};

  &.pb-15 {
    padding-bottom: 15px;
  }

  &.pb-20 {
    padding-bottom: 20px;
  }

  &.pb-25 {
    padding-bottom: 25px;
  }

  &.pt-25 {
    padding-top: 25px;
  }

  &.pb-30 {
    padding-bottom: 30px;
  }
`;

export const CancelOrRescheduleSection = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;

  h4 {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #1d201f;
  }

  ion-icon {
    font-size: 30px;
    color: #26b183;
  }
`;

export const PriceContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const DiscountText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: right;
  text-decoration: line-through;

  color: #1d201f;
`;

type HeadingsProps = {
  align?: string;
  capitalize?: boolean;
};

export const PaymentPageHeading = styled.h2<HeadingsProps>`
  text-transform: ${(props) => (props.capitalize ? 'capitalize' : 'none')};
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #1d201f;
  text-align: ${(props) => props.align ?? 'left'} !important;
`;

export const PaymentPageSubHeading = styled.h4<HeadingsProps>`
  text-transform: ${(props) => (props.capitalize ? 'capitalize' : 'none')};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  text-align: ${(props) => props.align ?? 'left'};
  color: #5b5b5b;
`;
